export const solotionTabItems = [
  {
    title: "آبجکت استوریج (Object Storage)",
    img: "cdn/domain.svg",
    imgAlt: "آبجکت استوریج (Object Storage) آبالون",
    imgTitle: "آبجکت استوریج (Object Storage) آبالون",
    img_deactive: "cdn/domain.svg",
    section_title: "آبجکت استوریج (Object Storage)",
    caption: `راهکار آبجکت استوریج آبالون، بستری پایدار، امن و مقیاس‌پذیر برای نگهداری حجم عظیمی از داده‌ها با ساختار دلخواه در فضای ذخیره‌سازی ابری فراهم می‌کند. این سرویس با سازگاری کامل با استاندارد <span style="font-family: Arial, Helvetica, sans-serif;">S3</span>، به‌راحتی با فرایندهای توسعه و زیرساخت‌های موجود سازمان شما یکپارچه می‌شود و فرآیند ذخیره‌سازی، آرشیو و بازیابی داده‌ها را ساده، امن و مطمئن می‌کند.`,
    contentImg: "header-cropped.svg",
    contentImgAlt: "آبجکت استوریج (Object Storage) آبالون",
    contentImgTitle: "آبجکت استوریج (Object Storage) آبالون",
    link: "/object-storage",
    linkTitle: "آشنایی با راهکار آبجکت استوریج آبالون",
    alt: " راهکار آبجکت استوریج آبالون",
    contentItem: [
      {
        name: "مقیاس‌پذیری نامحدود بدون نیاز به تغییر زیرساخت یا وقفه در سرویس",
      },
      {
        name: "امکان پیاده‌سازی توزیع‌شده در ریجن‌های مختلف برای پایداری داده‌ها",
      },
      {
        name: "قابل پیاده‌سازی روی کولوکیشن، سرور اختصاصی، ابر خصوصی یا زیرساخت سازمان",
      },
      {
        name: "مناسب برای نگهداری نسخه‌های پشتیبان، آرشیو بلندمدت و داده‌های چندرسانه‌ای",
      },
    ],
  },
  {
    title: "سرویس بکاپ سرور ابری آبالون",
    img: "cdn/report.svg",
    imgAlt: "سرویس بکاپ سرور ابری آبالون آبالون",
    imgTitle: "سرویس بکاپ سرور ابری آبالون آبالون",
    img_deactive: "cdn/report.svg",
    section_title: "سرویس بکاپ سرور ابری آبالون",
    caption:
      "با سرویس بکاپ سرور ابری آبالون، از داده‌های سازمانی خود به‌صورت مداوم و ایمن محافظت کنید. این سرویس با پشتیبان‌گیری خودکار و فضای ذخیره‌سازی پایدار و امن، راهکاری مطمئن برای حفظ و بازیابی اطلاعات حیاتی است و به شما امکان می‌دهد در برابر خرابی سخت‌افزار، حملات سایبری، خطاهای انسانی یا به‌روزرسانی‌های ناموفق از داده‌های خود محافظت کنید.",
    contentImg: "cloudGuard/firewall.svg",
    contentImgAlt: "سرویس بکاپ سرور ابری آبالون آبالون",
    contentImgTitle: "سرویس بکاپ سرور ابری آبالون آبالون",
    link: "/backup-solutions",
    linkTitle: "آشنایی با سرویس بکاپ سرور ابری آبالون",
    alt: "سرویس بکاپ سرور ابری آبالون",
    contentItem: [
      {
        name: "Replication در ریجن‌های مختلف برای اطمینان از پایداری داده‌ها",
      },
      {
        name: "تنوع راهکارهای بکاپ سرور ابری شامل Full ،Incremental و ترکیبی",
      },
      {
        name: "مقیاس‌پذیری بدون اختلال و تغییر ظرفیت فضای ذخیره‌سازی، بدون توقف سرویس",
      },
      {
        name: "ذخیره‌سازی توزیع‌شده با SDS",
      },
    ],
  },
  {
    title: "بازیابی پس از بحران (DR)",
    img: "cdn/ddos.svg",
    imgAlt: "بازیابی پس از بحران (DR)",
    imgTitle: "بازیابی پس از بحران (DR)",
    img_deactive: "cdn/ddos.svg",
    section_title: "بازیابی پس از بحران (DR)",
    caption:
      "راهکار بازیابی از بحران آبالون برای تضمین پایداری داده‌ها و سرویس‌های سازمان‌ها در زمان وقوع اختلال یا بحران طراحی شده است. این راهکار با بهره‌گیری از بیش از ۲۰ دیتاسنتر فعال در سراسر کشور و زیرساخت ابری منعطف، امکان استقرار در چند موقعیت جغرافیایی را فراهم می‌کند. تیم‌های تخصصی دواپس و پشتیبانی فنی آبالون با تجربه عملیاتی در پروژه‌های پیچیده، از مرحله طراحی تا اجرای راهکار در کنار شما خواهند بود.",
    contentImg: "security/ddos-image.svg",
    contentImgAlt: "بازیابی پس از بحران (DR)",
    contentImgTitle: "بازیابی پس از بحران (DR)",
    link: "/disaster-recovery",
    linkTitle: "آشنایی با راهکار بازیابی پس از بحران آبالون",
    alt: "راهکار بازیابی پس از بحران آبالون",
    contentItem: [
      {
        name: "شناسایی سرویس‌های حیاتی سازمان برای اولویت‌بندی بازیابی هنگام بحران",
      },
      {
        name: "تحلیل ریسک سناریو‌های حملات سایبری، قطعی زیرساخت و خطای انسانی",
      },
      {
        name: "استقرار Onsite یا Offsite با مدل‌های Active-Passive و Active-Active",
      },
      {
        name: "ارتباط بر بستر امن و اختصاصی نورونتا منطبق با الزامات سازمان پدافند غیرعامل ",
      },
    ],
  },
];

export const features = [
  {
    img: "focus.svg",
    title: "مقیاس‌پذیری نامحدود",
    title_en: "",
    desc: "امکان افزایش یا کاهش نامحدود ظرفیت ذخیره‌سازی در لحظه بدون اختلال یا وقفه در اجرای سرویس‌ها",
  },
  {
    img: "devops.svg",
    title: "چند ریجن و تنوع جغرافیایی",
    title_en: "",
    desc: "استقرار و تکثیر داده‌ها در چند مرکز داده‌ مستقل در استان‌های مختلف برای افزایش دسترس‌پذیری هنگام وقوع بحران",
  },
  {
    img: "technical.svg",
    title: "مدیریت یکپارچه",
    title_en: "",
    desc: "نظارت و کنترل فرایند‌های ذخیره‌سازی، بکاپ و بازیابی داده‌ها از طریق پنل مدیریتی یکپارچه تحت وب",
  },
  {
    img: "monitoring.svg",
    title: "مطابق با الزامات امنیتی",
    title_en: "",
    desc: "پایداری داده‌ها همراه با برآورده کردن الزامات امنیتی سازمان پدافند غیر‌عامل و مرکز مدیریت راهبردی افتا ",
  },
  {
    img: "exclusive.svg",
    title: "پشتیبان‌گیری و بازیابی سریع",
    title_en: "",
    desc: "بهره‌مندی از تجهیزات پرسرعت ذخیره‌سازی برای کاهش زمان پشتیبان‌گیری یا بازیابی داده‌ها در شرایط بحرانی",
  },
  {
    img: "hardening.svg",
    title: "سازگاری با زیرساخت‌های متنوع",
    title_en: "",
    desc: `پشتیبانی از پروتکل‌ها و پلتفرم‌های مختلف (مانند <span style="font-family: Arial, Helvetica, sans-serif;">S3</span>) و امکان استقرار در محیط‌های هیبرید و چند ابری`,
  },
];

export const locations = [
  {
    img: "VPS/iranServer.svg",
    name: "پایداری داده‌‌ها، منطبق بر الزامات امنیتی کشور",
    cap: "راهکارهای پایداری داده‌های آبالون بر اساس استانداردها و الزامات نهادهای امنیتی کشور، از جمله سازمان پدافند غیرعامل و مرکز مدیریت راهبردی افتا، طراحی و پیاده‌سازی شده است. با تکیه بر معماری توزیع‌شده و استقرار داده‌ها در ریجن‌های متعدد داخل کشور، بالاترین سطح دسترس‌پذیری برای سازمان‌ها تضمین می‌شود؛ به‌گونه‌ای که در صورت بروز بحران یا اختلال در هر یک از مراکز داده، امکان تداوم سرویس‌دهی و بازیابی سریع داده‌ها فراهم خواهد بود.",
    alt: "پایداری داده‌‌ها، منطبق بر الزامات امنیتی کشور",
    title: "پایداری داده‌‌ها، منطبق بر الزامات امنیتی کشور",
    class: "iranImg",
  },

  {
    img: "cdn/IranMap.svg",
    name: "پایداری داده‌ها و سرویس‌ها؛ ارتباط بر بستر امن و اختصاصی نورونتا",
    cap: "راهکارهای پایداری داده آبالون این امکان را برای سازمان‌ها فراهم می‌کند که در هر نقطه از کشور بتوانند از طریق شبکه‌ انتقال داده‌ اختصاصی، ایمن و فوق سریع نورونتا، اقدام به پشتیبان‌گیری اطلاعات خود در دیتاسنترهای آبالون یا بازیابی آنها کنند. این بستر با اتکا به زیرساخت پایدار و ظرفیت انتقال بالا، جابه‌جایی داده‌ها را کاملاً مستقل از اینترنت عمومی انجام داده و بالاترین سطح امنیت را در فرآیند انتقال اطلاعات تضمین می‌کند.",
    alt: "پایداری داده‌ها و سرویس‌ها؛ ارتباط بر بستر امن و اختصاصی نورونتای",
    title: "پایداری داده‌ها و سرویس‌ها؛ ارتباط بر بستر امن و اختصاصی نورونتای",
    class: "iranImg",
  },
];

export const popularServices = [
  {
    title: "امنیت ابری",
    desc: "با استفاده از راهکارهای امنیتی پیشرفته مانند فضای کاری امن، فایروال ابری، WAF و سامانه (SIEM) از سرویس‌های سازمانی خود در فضای ابری محافظت کنید. ",
    logo: "CloudGuard-Service.svg",
    route: "/cloud-security",
  },
  {
    title: "خدمات محافظت از DDoS آبالون",
    desc: "با راهکارهای پیشرفته‌ محافظت در برابر حملات DDoS، ترافیک مخرب پیش از رسیدن به سرورهای اصلی سازمان شما شناسایی و مسدود می‌شود.",
    logo: "VPS-Service.svg",
    route: "/ddos-protection",
  },
  {
    title: "دیتاسنتر ابری",
    desc: "دیتاسنتر ابری تمامی قابلیت‌های یک دیتاسنتر فیزیکی را روی ابر برایتان فراهم می‌کند و می‌تواند پاسخی برای پیچیده‌ترین و تخصصی‌ترین نیازهای ابری شما باشد. ",
    logo: "VPC-Service.svg",
    route: "/vpc",
  },
  {
    title: "شبکه توزیع محتوای CDN آبالون",
    desc: "با بیش از ۴۰ پاپ‌سایت فعال در ایران و ۵ قاره جهان، محتوای وب‌سایت و سرویس‌های آنلاین سازمان خود را با کمترین تأخیر، سریع‌تر و ایمن‌تر به کاربران برسانید. ",
    logo: "ManagedService-Service.svg",
    route: "/cdn",
  },
];

export const questions = [
  {
    title:
      "راهکارهای پایداری داده‌ آبالون چه نقشی در امنیت و تداوم کسب‌وکار دارد؟",
    answer:
      "این راهکار با ترکیب سه سرویس اصلی شامل آبجکت استوریج، بکاپ ابری و بازیابی از بحران (DR)، زیرساختی پایدار برای ذخیره‌سازی و بازیابی داده‌ها فراهم می‌کند. بدین ترتیب، سازمان‌ها می‌توانند پایداری داده‌ها و تداوم در دسترس بودن سرویس‌های سازمان خود را در برابر خرابی سخت‌افزار، خطای انسانی یا حملات سایبری تضمین کنند.",
  },
  {
    title:
      "آیا امکان استفاده از این راهکارها در محیط‌های چندابری یا هیبریدی وجود دارد؟",
    answer: `بله. راهکار پایداری داده‌های آبالون با پشتیبانی از پروتکل‌های استاندارد مانند <span style="font-family: Arial, Helvetica, sans-serif;">S3</span> و سازگاری با زیرساخت‌های متنوع، قابلیت استقرار در محیط‌های چندابری و هیبریدی را دارد. این انعطاف‌پذیری به سازمان‌ها کمک می‌کند متناسب با نیاز خود بهترین معماری پایداری داده و سرویس را پیاده‌سازی کنند.`,
  },
  {
    title: "سرویس بکاپ ابری آبالون چگونه از داده‌ها محافظت می‌کند؟",
    answer:
      "این سرویس با پشتیبان‌گیری خودکار، ذخیره‌سازی توزیع‌شده و قابلیت Replication در ریجن‌های مختلف، امنیت و پایداری داده‌ها را تضمین می‌کند. همچنین از مدل‌های متنوع بکاپ مانند Full، Incremental و ترکیبی پشتیبانی کرده و بازیابی سریع داده‌ها را در شرایط بحرانی امکان‌پذیر می‌سازد.",
  },
  {
    title: "در صورت وقوع بحران یا اختلال، راهکار DR آبالون چه مزیتی دارد؟",
    answer:
      "راهکار DR با بهره‌گیری از بیش از ۲۰ دیتاسنتر فعال در کشور و معماری توزیع‌شده، امکان استقرار Onsite یا Offsite با مدل‌های Active-Active و Active-Passive را فراهم می‌کند. این قابلیت موجب می‌شود سرویس‌های حیاتی سازمان حتی در شرایط بحرانی بدون وقفه در دسترس باقی بمانند.",
  },
  {
    title:
      "آیا راهکار پایداری داده‌های آبالون منطبق بر الزامات امنیتی کشور است؟",
    answer:
      "طراحی و پیاده‌سازی این راهکار بر اساس الزامات سازمان پدافند غیرعامل و مرکز مدیریت راهبردی افتا انجام شده است و تمام مؤلفه‌ها با استانداردهای امنیتی هم‌راستا هستند.",
  },
];
